



























import { toV, compressImage, routerPush } from '@/app/core/utils'
import { join, slice } from 'lodash'
import { Vue, Component, Prop } from 'vue-property-decorator'

const avatar = require('@assets/images/avatar_advi@3x.png')

@Component({
  filters: {
    avatar(src: string | undefined) {
      return src ? src : avatar
    },
  },
})
export default class Consultant extends Vue {
  @Prop({ default: [] }) readonly list!: any[]
  @Prop({ default: [] }) readonly spuIds!: any[]

  get showList() {
    return slice(this.list, 0, 10)
  }

  toUser(item: any) {
    toV({ name: 'user', params: { uid: item.uid } })
  }
  handleMore() {
    const spuIds = join(this.spuIds, ',')
    
    routerPush({ name: 'consultantList', query: { spuIds } })
  }
}
